import React, {Fragment, useState, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Cord
import {makeStyles, withStyles, createStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'

// Material-UI Icon
import AddIcon from '@material-ui/icons/Add'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import SaveIcon from '@material-ui/icons/Save'

// Material-UI Element
//import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Component
import useLoading from "../Loading/useLoading"
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import WebViewer from "../WebViewer/WebViewer"

// Custom Style
import {redColor, oceanBlueColor, grayColor, whiteColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import {viewDrawingFormStyle} from '../../styles/jss/components/drawingRegister/viewDrawingFormStyle'

// Fetch Data
import {getCoverType, getCoverDetail, updateCover, getPurposeType, getDrawingTypeAndGroup, getDrawingDetail, updateDrawing} from '../../dataSource/drawingRegister'


// Custom Style (Typography)
const PurposeTypography = withStyles({
	root: {
		"fontSize": 13,
		"fontWeight": 600,
		// "color": "#ff3399"
	},
}) (Typography)

const ValidationErrorMsgTypography = withStyles({
	root: {
		"fontSize": 12.,
		"fontWeight": 400,
		"color": redColor[6]
	},
}) (Typography)

const SelectMenuItem = withStyles((theme) =>
	createStyles({
		root: {
			"&$selected": {
				backgroundColor: oceanBlueColor[8],

				"&:hover": {
					color: whiteColor,
					backgroundColor: oceanBlueColor[12]
				}
			},

			"&:hover": {
				backgroundColor: oceanBlueColor[1]
			}
		},
		selected: {}
	})
)(MenuItem)


const useStyles = makeStyles(theme => viewDrawingFormStyle(theme))

const ViewDrawingForm = props => {
	const {selectedDrawing, setDrawingRefash} = props
	const classes = useStyles()
	const dispatch = useDispatch()
	
	// Redux Data
	// const relatedItemPropertyRedux = useSelector(state => state.relatedItemPropertyRedux)
	
	// Loading 
	const [getDrawingLoading, getDrawingShowLoading, getDrawingHiddenLoading] = useLoading()

	// State Variable
	const [purposeType, setPurposeType] = useState(null)
	const [dwgTypeGroupAndType, setDwgTypeGroupAndType] = useState(null)
	const [dwgType, setDwgType] = useState(null)
	const [drawingDetailRecord, setDrawingDetailRecord] = useState(null)
	const [drawingDetailRecordProperty, setDrawingDetailRecordProperty] = useState(null)
	const [validationErrors, setValidationErrors] = useState({})
	const [dwgTypeGroupSelected, setDwgTypeGroupSelected] = useState("")
	const [dwgTypeSelected, setDwgTypeSelected] = useState([])
	const [dwgTagName, setDwgTagName] = useState("")

	// Dialog contral state
	// const [fileManagerDialogOpen, setFileManagerDialogOpen] = useState(false)
	// const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false)

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}


	// Input Control
	const handleChangePurpose = (event, newPurpose) => {
		const res = {...drawingDetailRecordProperty}
		res.dwg_purposes = newPurpose

		setDrawingDetailRecordProperty(res)
		validate(res)
   }

	const handleTextChange = event => {
		const {name, value} = event.target
		const res = {...drawingDetailRecordProperty}
		res[name] = value

		setDrawingDetailRecordProperty(res)
		validate(res)
	}

	const handleChangeDwgTypeGroup = event => {
		const {value} = event.target
		const res = {...drawingDetailRecordProperty}

		res.dwg_type_group = value
		res.dwg_types = []
		res.dwg_type_names = []

		setDwgTypeGroupSelected(value)
		setDwgTypeSelected([])
		setDwgType(null)

		setDrawingDetailRecordProperty(res)

		dwgTypeGroupAndType.map(res => {
			if (res.type_group_seq === event.target.value) {
				setDwgType(res.types)
			}
		})

		validate(res)
	}

	const handleChangeDwgType = (event, child) => {
		const {id} = child.props
		const {value} = event.target
		const res = {...drawingDetailRecordProperty}

		const newSelected = dwgTypeSelected

		newSelected.push(id)
		setDwgTypeSelected(newSelected)

		res.dwg_types = newSelected
		res.dwg_type_names = value
		
		setDrawingDetailRecordProperty(res)
		validate(res)
	}

	const handleTextChangeDwgTag = event => {
		const {value} = event.target
		setDwgTagName(value)
	}

	const handleAddTags = () => {
		const res = {...drawingDetailRecordProperty}
		const newTag = res.dwg_tags

		newTag.push(dwgTagName)
		res.dwg_tags = newTag

		setDwgTagName("")
		setDrawingDetailRecordProperty(res)
	}

	const handleTagDelete = (tagName) => () => {
		const res = {...drawingDetailRecordProperty}
		const newTags = res.dwg_tags.filter(deleteItem => deleteItem !== tagName)

		res.dwg_tags = newTags

		setDrawingDetailRecordProperty(res)
	}


	// Confirm Dialog Control Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Action
	const updateDrawingConfirmAction = () => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Update Drawing Record",
				dialogContent: "Are you sure to save change.",
				confirmAction: updateDrawingAction,
				cancelAction: updateDrawingCancelAction
			})
		}
	}

	const updateDrawingAction = () => {
		updateDrawing(drawingDetailRecordProperty.dwg_seq, drawingDetailRecordProperty).then(res => {
			confirmDialogHandleClose()
			
			if (res.type === "success") {
				setDrawingRefash(res.code)
				
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "success",
					title: "Success Alert",
					content: "The drawing record have been updated"
				})

				// setTimeout(() => {
				// 	viewRelatedItemDialogHandleClose()
				// }, 2000)
			}
			else {
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "error",
					title: "Error Alert",
					content: res.message
				})
			}
		}).catch(error => {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "error",
				title: "Error Alert",
				content: error.message
			})
		})
	}

	const updateDrawingCancelAction = () => {
		confirmDialogHandleClose()
	}


	// Input Validation
	const validate = (fieldValues = drawingDetailRecordProperty) => {
		let temp = {...validationErrors}
	 
		if ("dwg_purposes" in fieldValues) {
			temp.dwg_purposes = fieldValues.dwg_purposes.length > 0 ? "" : "This field is required"
		}

		if ("dwg_no" in fieldValues) {
			temp.dwg_no = fieldValues.dwg_no ? "" : "This field is required"
		}

		if ("dwg_title" in fieldValues) {
			temp.dwg_title = fieldValues.dwg_title ? "" : "This field is required"
		}

		if ("dwg_type_group" in fieldValues) {
			temp.dwg_type_group = fieldValues.dwg_type_group ? "" : "This field is required"
		}

		if ("dwg_types" in fieldValues) {
			temp.dwg_types = fieldValues.dwg_types.length > 0 ? "" : "This field is required"
		}
		
		setValidationErrors({...temp})

		if (fieldValues == drawingDetailRecordProperty) {
			return Object.values(temp).every(x => x == "")
		}
	}


	useEffect(() => {
		getDrawingShowLoading()

		getPurposeType().then(res => {
			setPurposeType(res)
		})
		.catch(error => {
			console.error("Get drawing detail record error: ", error)
		})

		getDrawingTypeAndGroup().then(res => {
			setDwgTypeGroupAndType(res)
		})
		.catch(error => {
			console.error("Get drawing detail record error: ", error)
		})

		getDrawingDetail(selectedDrawing.dwg_seq).then(res => {
			getDrawingTypeAndGroup().then(typeGroupsRes => {
				setDwgTypeGroupAndType(typeGroupsRes)

				typeGroupsRes.map(group => {
					console.log("group.type_group_seq : ", group.type_group_seq)
					console.log("res.data[0].dwg_type_group : ", res.data[0].dwg_type_group)

					if (group.type_group_seq === res.data[0].dwg_type_group) {
						setDwgType(group.types)
					}
				})

			})
			.catch(error => {
				console.error("Get drawing detail record error: ", error)
			})

			setDrawingDetailRecord(res.data[0])
			setDrawingDetailRecordProperty(res.data[0])

			getDrawingHiddenLoading()
		})
		.catch(error => {
			console.error("Get drawing detail record error: ", error)
		})
	}, [])


	return (
		// console.log("Drawing Type Group and Type | Variable: dwgTypeGroupAndType (viewDrawingForm.js)"),
		// console.log(dwgTypeGroupAndType),

		// console.log("Drawing Type | Variable: dwgType (viewDrawingForm.js)"),
		// console.log(dwgType),

		// console.log("Selected Drawing Record | Variable: selectedDrawing (viewDrawingForm.js)"),
		// console.log(selectedDrawing),

		// console.log("Drawing Detail Record | Variable: drawingDetailRecord (viewDrawingForm.js)"),
		// console.log(drawingDetailRecord),

		// console.log("Drawing Detail Record for Update Drawing | Variable: drawingDetailRecordProperty (viewDrawingForm.js)"),
		// console.log(drawingDetailRecordProperty),

		// console.log("Validation Error | Variable: validationErrors (viewDrawingForm.js)"),
		// console.log(validationErrors),
		
		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>
			</div> 

			{getDrawingLoading}
			{
				drawingDetailRecordProperty ?
					<Grid container spacing={1} className={classes.fieldGridArea}>
						<Grid item xs={12} sm={12} lg={4}>

							<Grid container spacing={3}>
								<Grid item xs={12} sm={12} lg={12}>
									<ToggleButtonGroup value={drawingDetailRecordProperty.dwg_purposes} onChange={handleChangePurpose} aria-label="dwg_purpose" className={classes.ToggleButtonGroup}>
										{
											purposeType ?
												purposeType.map(res => {
													return (
														<ToggleButton 
															key={res.purpose_seq}
															aria-label={res.purpose_name}
															value={res.purpose_seq}
															className={classes.ToggleButton_25}
														>
															<PurposeTypography style={{color: res.color}}>{res.name}</PurposeTypography>
														</ToggleButton>
													)
												})
											: ""
										}
									</ToggleButtonGroup>
									{
										validationErrors.dwg_purposes && validationErrors.dwg_purposes !== "" ? 
											<ValidationErrorMsgTypography className={classes.validationErrorMsg}>{validationErrors.dwg_purposes}</ValidationErrorMsgTypography> 
										: ""
									}
								</Grid>

								<Grid item xs={12} sm={12} lg={12}>
									<TextField
										id={"dwg_no"}
										name="dwg_no"
										label="Drawing No."
										required
										fullWidth={true}
										size="small"
										variant="outlined"
										value={drawingDetailRecordProperty.dwg_no}
										onChange={handleTextChange}
										InputLabelProps={{
											shrink: true,
										}}
										error={validationErrors.dwg_no && validationErrors.dwg_no !== "" ? true : false}
										helperText={validationErrors.dwg_no}
									/>
								</Grid>

								<Grid item xs={12} sm={12} lg={12}>
									<TextField
										id={"dwg_title"}
										name="dwg_title"
										label="Drawing Title"
										required
										fullWidth={true}
										size="small"
										variant="outlined"
										value={drawingDetailRecordProperty.dwg_title}
										onChange={handleTextChange}
										InputLabelProps={{
											shrink: true,
										}}
										error={validationErrors.dwg_title && validationErrors.dwg_title !== "" ? true : false}
										helperText={validationErrors.dwg_title}
									/>
								</Grid>

								<Grid item xs={12} sm={12} lg={12}>
									<FormControl required variant="outlined" size="small" className={classes.formControl}>
										<InputLabel id="dwg-type-group-label">DWG Type Group</InputLabel>
										<Select
											id={"dwg_type_group"}
											labelId="dwg_type_group_label"
											label="DWG Type Group"
											value={drawingDetailRecordProperty.dwg_type_group}
											onChange={handleChangeDwgTypeGroup}
											// InputLabelProps={{
											// 	shrink: false,
											// }}
										>
											{
												dwgTypeGroupAndType ?
													dwgTypeGroupAndType.map(res => {
														return (
															<SelectMenuItem key={res.type_group_seq} value={res.type_group_seq}>{res.type_group_name}</SelectMenuItem>
														)
													})
												: ""
											}
										</Select>
									</FormControl>
									{
										validationErrors.dwg_type_group && validationErrors.dwg_type_group !== "" ? 
											<ValidationErrorMsgTypography className={classes.validationErrorMsg}>{validationErrors.dwg_type_group}</ValidationErrorMsgTypography> 
										: ""
									}
								</Grid>

								<Grid item xs={12} sm={12} lg={12}>
									<FormControl required variant="outlined" size="small" className={classes.formControl}>
										<InputLabel id="dwg-type-label">DWG Type</InputLabel>
										<Select
											id="dwg_types"
											labelId="dwg_type_label"
											label="DWG Type"
											value={drawingDetailRecordProperty.dwg_type_names}
											multiple
											onChange={handleChangeDwgType}
											
											renderValue={selected => (
												<div className={classes.chips}>
													{
														selected.map(value => (
															<Chip key={value} label={value} className={classes.chip} />
														))
													}
												</div>
											)}
										>
											{
												dwgType ?
													dwgType.map(res => (
														<SelectMenuItem key={res.type_seq} id={res.type_seq} value={res.type_name}>{res.type_name}</SelectMenuItem>
													))
												: ""
											}
										</Select>
									</FormControl>
									{
										validationErrors.dwg_types && validationErrors.dwg_types !== "" ? 
											<ValidationErrorMsgTypography className={classes.validationErrorMsg}>{validationErrors.dwg_types}</ValidationErrorMsgTypography> 
										: ""
									}
								</Grid>

								<Grid item xs={10} sm={10} lg={10}>
									<TextField
										id={"dwg_tag"}
										name="dwg_tag"
										label="Drawing Tag"
										fullWidth={true}
										size="small"
										variant="outlined"
										value={drawingDetailRecordProperty.dwg_tag}
										onChange={handleTextChangeDwgTag}
										InputLabelProps={{
											shrink: true,
										}}
										// error={validationErrors.cover_no && validationErrors.cover_no !== "" ? true : false}
										// helperText={validationErrors.cover_no}
									/>
								</Grid>

								<Grid item xs={2} sm={2} lg={2}>
									<Tooltip title="Add Tag">
										<span>
											<Fab 
												aria-label="add_Tag"
												color="primary"
												size="small"
												onClick={handleAddTags}
												className={classes.tagBtn}
											>
												<AddIcon />
											</Fab>
										</span>
									</Tooltip>
								</Grid>

								<Grid item xs={12} sm={12} lg={12}>
									<Paper variant="outlined" className={classes.tagArea}>
										{
											drawingDetailRecordProperty ?
												drawingDetailRecordProperty.dwg_tags.map((tag, i) => {
													return (
														<Chip
															key={i}
															label={tag}
															icon={<LocalOfferIcon />}
															variant="outlined"
															size="small"
															onDelete={handleTagDelete(tag)}
															style={{paddingLeft: 5, paddingRight: 0, paddingTop: 5, paddingBottom: 5, marginRight: 10}}
														/>
													)
												})
											: ""
										}
									</Paper>
								</Grid>

								<Grid item xs={12} sm={12} lg={12}>
									{/* <Button variant="contained" color="primary" onClick={updateDrawingConfirmAction} className={classes.toolMenuBtn}>
										Save
									</Button> */}

									<Tooltip title="Save">
										<Fab 
											color="primary"
											size="small"
											onClick={updateDrawingConfirmAction}
											className={classes.toolMenuBtn}
										>
											<SaveIcon />
										</Fab>
									</Tooltip>
								</Grid>
							</Grid>
						</Grid>

						<Grid item xs={12} sm={12} lg={8}>
							<WebViewer
								property={{
									from: "API",
									autoLoading: true,
									file_cat: drawingDetailRecordProperty.current_rev.file_cat,
									file_ref: drawingDetailRecordProperty.current_rev.rev_seq,
									file_name: drawingDetailRecordProperty.dwg_no + ".pdf",
								}}
							/>
						</Grid>

					</Grid>
				: ""
			}
		</Fragment>
	)
}


export default ViewDrawingForm